export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/audience.55d6a362.svg","height":203,"width":320,"blurWidth":0,"blurHeight":0};